<template>
  <sec-section>
    <sec-section-heading :eyebrow="ladder.eyebrow" :title="ladder.title">
      <p class="m500 sec-body">{{ ladder.intro }}</p>
    </sec-section-heading>
    <sec-data-table :columns="ladder.columns" :rows="ladder.rows" />
    <p class="m500 sec-body" data-reveal>{{ ladder.closing }}</p>
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSectionHeading from '@/components/security/ui/SecSectionHeading.vue';
import SecDataTable from '@/components/security/ui/SecDataTable.vue';
import { SERVICES } from '@/content/security/services';

const ladder = SERVICES.ladder;
</script>
